export default __webpack_public_path__ + "static/5-734fda87651cee2e04c1c42813fe8552.png";